import * as React from 'react';
import { MouseEventHandler, ReactNode, useCallback, useState } from "react";

interface IRange { start: number, end: number }

interface Props {
  text: string,
  size: number,
  textRenderer?: (text: string) => ReactNode,
  getProtectedRanges?: (text: string) => IRange[],
}

// If the index is inside any protected range, return end index of that range.
// Go recursively if the end of the protected range is inside any other range.
function protect(index: number, protectedRanges: IRange[]): number {
  const range = protectedRanges.find(r => r.start <= index && index < r.end);
  return range !== undefined ? protect(range.end, protectedRanges) : index;
}

export default function ShowMoreText(props: Props) {
  const [show, setShow] = useState<boolean>(false);
  const toggle: MouseEventHandler<HTMLAnchorElement> = useCallback((e) => {
    e.preventDefault();
    setShow(show => !show);
  }, []);

  // Render section:

  const spacePos = props.text.indexOf(" ", props.size);

  const trimmedText = (() => {
    if (spacePos >= 0 && !show) {
      let pos: number;
      if (props.getProtectedRanges !== undefined) {
        pos = protect(spacePos, props.getProtectedRanges(props.text));
      } else {
        pos = spacePos;
      }
      return props.text.slice(0, pos);
    } else {
      return props.text;
    }
  })();

  const renderedText: ReactNode = props.textRenderer?.(trimmedText) ?? trimmedText;

  if (spacePos < 0) {
    return <>{renderedText}</>
  } else if (show) {
    return <>
      {renderedText} <a href="#" onClick={toggle}>show less</a>
    </>
  } else {
    return <>
      {renderedText}… <a href="#" onClick={toggle}>show more</a>
    </>
  }
}
